import { createSlice } from '@reduxjs/toolkit';
import { userPermissionsInitialState } from '../initialStates/userPermissions';

const setUserPermissions = (state, action) => {
  Object.keys(action.payload).forEach(permission => {
    state[permission] = action.payload[permission];
  });
};
const setPermissionRequestStatus = (state, action) => {
  state.permissionRequested = action.payload;
};

const userPermissionsSlice = createSlice({
  name: 'userPermissions',
  initialState: userPermissionsInitialState,
  reducers: {
    setUserPermissions,
    setPermissionRequestStatus,
  },
});

export const userPermissionsActions = userPermissionsSlice.actions;

export default userPermissionsSlice.reducer;
